/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AppRouteRouteImport } from './routes/_app/route'
import { Route as AuthRouteRouteImport } from './routes/_auth/route'
import { Route as KitRouteImport } from './routes/kit'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as AppWorkspaceSlugRouteRouteImport } from './routes/_app/$workspaceSlug/route'
import { Route as AppNewRouteImport } from './routes/_app/new'
import { Route as AuthForgotPasswordRouteImport } from './routes/_auth/forgot-password'
import { Route as AuthLoginRouteImport } from './routes/_auth/login'
import { Route as AuthSignupRouteImport } from './routes/_auth/signup'
import { Route as DocsIndexRouteImport } from './routes/docs/index'
import { Route as DocsPageRouteImport } from './routes/docs/$page'
import { Route as GithubCallbackRouteImport } from './routes/github.callback'
import { Route as InviteInvitationIdRouteImport } from './routes/invite.$invitationId'
import { Route as SlackCallbackRouteImport } from './routes/slack.callback'
import { Route as AppWorkspaceSlugIndexRouteImport } from './routes/_app/$workspaceSlug/index'
import { Route as AppWorkspaceSlugProjectSlugRouteRouteImport } from './routes/_app/$workspaceSlug/$projectSlug/route'
import { Route as AppWorkspaceSlugBoardRouteImport } from './routes/_app/$workspaceSlug/board'
import { Route as AppWorkspaceSlugCyclesRouteImport } from './routes/_app/$workspaceSlug/cycles'
import { Route as AppWorkspaceSlugInboxRouteImport } from './routes/_app/$workspaceSlug/inbox'
import { Route as AppWorkspaceSlugMyIssuesRouteImport } from './routes/_app/$workspaceSlug/my-issues'
import { Route as AppWorkspaceSlugPulseRouteImport } from './routes/_app/$workspaceSlug/pulse'
import { Route as AppWorkspaceSlugSettingsRouteRouteImport } from './routes/_app/$workspaceSlug/settings/route'
import { Route as AppWorkspaceSlugStackRouteImport } from './routes/_app/$workspaceSlug/stack'
import { Route as AppWorkspaceSlugStatsRouteImport } from './routes/_app/$workspaceSlug/stats'
import { Route as AppWorkspaceSlugWorkRouteImport } from './routes/_app/$workspaceSlug/work'
import { Route as PSlugIndexRouteImport } from './routes/p.$slug.index'
import { Route as PSlugChangelogRouteImport } from './routes/p.$slug.changelog'
import { Route as AppWorkspaceSlugProjectSlugIndexRouteImport } from './routes/_app/$workspaceSlug/$projectSlug/index'
import { Route as AppWorkspaceSlugProjectSlugArchitectureRouteImport } from './routes/_app/$workspaceSlug/$projectSlug/architecture'
import { Route as AppWorkspaceSlugProjectSlugChangelogRouteImport } from './routes/_app/$workspaceSlug/$projectSlug/changelog'
import { Route as AppWorkspaceSlugProjectSlugExperimentsRouteImport } from './routes/_app/$workspaceSlug/$projectSlug/experiments'
import { Route as AppWorkspaceSlugProjectSlugPullsRouteImport } from './routes/_app/$workspaceSlug/$projectSlug/pulls'
import { Route as AppWorkspaceSlugProjectSlugRatingsRouteImport } from './routes/_app/$workspaceSlug/$projectSlug/ratings'
import { Route as AppWorkspaceSlugProjectSlugRoadmapRouteImport } from './routes/_app/$workspaceSlug/$projectSlug/roadmap'
import { Route as AppWorkspaceSlugProjectSlugTriageRouteImport } from './routes/_app/$workspaceSlug/$projectSlug/triage'
import { Route as AppWorkspaceSlugProjectSlugUpdatesRouteImport } from './routes/_app/$workspaceSlug/$projectSlug/updates'
import { Route as AppWorkspaceSlugSettingsIndexRouteImport } from './routes/_app/$workspaceSlug/settings/index'
import { Route as AppWorkspaceSlugSettingsAccountRouteImport } from './routes/_app/$workspaceSlug/settings/account'
import { Route as AppWorkspaceSlugSettingsAgentsRouteImport } from './routes/_app/$workspaceSlug/settings/agents'
import { Route as AppWorkspaceSlugSettingsIntegrationsRouteImport } from './routes/_app/$workspaceSlug/settings/integrations'
import { Route as AppWorkspaceSlugSettingsMembersRouteImport } from './routes/_app/$workspaceSlug/settings/members'
import { Route as AppWorkspaceSlugSettingsWorkspaceRouteImport } from './routes/_app/$workspaceSlug/settings/workspace'
import { Route as AppWorkspaceSlugProjectSlugDocumentsIndexRouteImport } from './routes/_app/$workspaceSlug/$projectSlug/documents/index'
import { Route as AppWorkspaceSlugProjectSlugDocumentsDocumentIdRouteImport } from './routes/_app/$workspaceSlug/$projectSlug/documents/$documentId'
import { Route as AppWorkspaceSlugProjectSlugIssuesIndexRouteImport } from './routes/_app/$workspaceSlug/$projectSlug/issues/index'
import { Route as AppWorkspaceSlugProjectSlugIssuesNumberRouteImport } from './routes/_app/$workspaceSlug/$projectSlug/issues/$number'
import { Route as AppWorkspaceSlugProjectSlugTicketsIndexRouteImport } from './routes/_app/$workspaceSlug/$projectSlug/tickets/index'
import { Route as AppWorkspaceSlugProjectSlugTicketsNumberRouteImport } from './routes/_app/$workspaceSlug/$projectSlug/tickets/$number'
import { Route as AppWorkspaceSlugSettingsProjectsIndexRouteImport } from './routes/_app/$workspaceSlug/settings/projects/index'
import { Route as AppWorkspaceSlugSettingsProjectsProjectSlugRouteImport } from './routes/_app/$workspaceSlug/settings/projects/$projectSlug'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRouteRoute = AppRouteRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRouteRoute = AuthRouteRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const KitRoute = KitRouteImport.update({
  id: '/kit',
  path: '/kit',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const AppWorkspaceSlugRouteRoute = AppWorkspaceSlugRouteRouteImport.update({
  id: '/$workspaceSlug',
  path: '/$workspaceSlug',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppNewRoute = AppNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AppRouteRoute,
} as any)
const AuthForgotPasswordRoute = AuthForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthLoginRoute = AuthLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthSignupRoute = AuthSignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => AuthRouteRoute,
} as any)
const DocsIndexRoute = DocsIndexRouteImport.update({
  id: '/docs/',
  path: '/docs/',
  getParentRoute: () => rootRouteImport,
} as any)
const DocsPageRoute = DocsPageRouteImport.update({
  id: '/docs/$page',
  path: '/docs/$page',
  getParentRoute: () => rootRouteImport,
} as any)
const GithubCallbackRoute = GithubCallbackRouteImport.update({
  id: '/github/callback',
  path: '/github/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const InviteInvitationIdRoute = InviteInvitationIdRouteImport.update({
  id: '/invite/$invitationId',
  path: '/invite/$invitationId',
  getParentRoute: () => rootRouteImport,
} as any)
const SlackCallbackRoute = SlackCallbackRouteImport.update({
  id: '/slack/callback',
  path: '/slack/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const AppWorkspaceSlugIndexRoute = AppWorkspaceSlugIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppWorkspaceSlugRouteRoute,
} as any)
const AppWorkspaceSlugProjectSlugRouteRoute =
  AppWorkspaceSlugProjectSlugRouteRouteImport.update({
    id: '/$projectSlug',
    path: '/$projectSlug',
    getParentRoute: () => AppWorkspaceSlugRouteRoute,
  } as any)
const AppWorkspaceSlugBoardRoute = AppWorkspaceSlugBoardRouteImport.update({
  id: '/board',
  path: '/board',
  getParentRoute: () => AppWorkspaceSlugRouteRoute,
} as any)
const AppWorkspaceSlugCyclesRoute = AppWorkspaceSlugCyclesRouteImport.update({
  id: '/cycles',
  path: '/cycles',
  getParentRoute: () => AppWorkspaceSlugRouteRoute,
} as any)
const AppWorkspaceSlugInboxRoute = AppWorkspaceSlugInboxRouteImport.update({
  id: '/inbox',
  path: '/inbox',
  getParentRoute: () => AppWorkspaceSlugRouteRoute,
} as any)
const AppWorkspaceSlugMyIssuesRoute =
  AppWorkspaceSlugMyIssuesRouteImport.update({
    id: '/my-issues',
    path: '/my-issues',
    getParentRoute: () => AppWorkspaceSlugRouteRoute,
  } as any)
const AppWorkspaceSlugPulseRoute = AppWorkspaceSlugPulseRouteImport.update({
  id: '/pulse',
  path: '/pulse',
  getParentRoute: () => AppWorkspaceSlugRouteRoute,
} as any)
const AppWorkspaceSlugSettingsRouteRoute =
  AppWorkspaceSlugSettingsRouteRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AppWorkspaceSlugRouteRoute,
  } as any)
const AppWorkspaceSlugStackRoute = AppWorkspaceSlugStackRouteImport.update({
  id: '/stack',
  path: '/stack',
  getParentRoute: () => AppWorkspaceSlugRouteRoute,
} as any)
const AppWorkspaceSlugStatsRoute = AppWorkspaceSlugStatsRouteImport.update({
  id: '/stats',
  path: '/stats',
  getParentRoute: () => AppWorkspaceSlugRouteRoute,
} as any)
const AppWorkspaceSlugWorkRoute = AppWorkspaceSlugWorkRouteImport.update({
  id: '/work',
  path: '/work',
  getParentRoute: () => AppWorkspaceSlugRouteRoute,
} as any)
const PSlugIndexRoute = PSlugIndexRouteImport.update({
  id: '/p/$slug/',
  path: '/p/$slug/',
  getParentRoute: () => rootRouteImport,
} as any)
const PSlugChangelogRoute = PSlugChangelogRouteImport.update({
  id: '/p/$slug/changelog',
  path: '/p/$slug/changelog',
  getParentRoute: () => rootRouteImport,
} as any)
const AppWorkspaceSlugProjectSlugIndexRoute =
  AppWorkspaceSlugProjectSlugIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppWorkspaceSlugProjectSlugRouteRoute,
  } as any)
const AppWorkspaceSlugProjectSlugArchitectureRoute =
  AppWorkspaceSlugProjectSlugArchitectureRouteImport.update({
    id: '/architecture',
    path: '/architecture',
    getParentRoute: () => AppWorkspaceSlugProjectSlugRouteRoute,
  } as any)
const AppWorkspaceSlugProjectSlugChangelogRoute =
  AppWorkspaceSlugProjectSlugChangelogRouteImport.update({
    id: '/changelog',
    path: '/changelog',
    getParentRoute: () => AppWorkspaceSlugProjectSlugRouteRoute,
  } as any)
const AppWorkspaceSlugProjectSlugExperimentsRoute =
  AppWorkspaceSlugProjectSlugExperimentsRouteImport.update({
    id: '/experiments',
    path: '/experiments',
    getParentRoute: () => AppWorkspaceSlugProjectSlugRouteRoute,
  } as any)
const AppWorkspaceSlugProjectSlugPullsRoute =
  AppWorkspaceSlugProjectSlugPullsRouteImport.update({
    id: '/pulls',
    path: '/pulls',
    getParentRoute: () => AppWorkspaceSlugProjectSlugRouteRoute,
  } as any)
const AppWorkspaceSlugProjectSlugRatingsRoute =
  AppWorkspaceSlugProjectSlugRatingsRouteImport.update({
    id: '/ratings',
    path: '/ratings',
    getParentRoute: () => AppWorkspaceSlugProjectSlugRouteRoute,
  } as any)
const AppWorkspaceSlugProjectSlugRoadmapRoute =
  AppWorkspaceSlugProjectSlugRoadmapRouteImport.update({
    id: '/roadmap',
    path: '/roadmap',
    getParentRoute: () => AppWorkspaceSlugProjectSlugRouteRoute,
  } as any)
const AppWorkspaceSlugProjectSlugTriageRoute =
  AppWorkspaceSlugProjectSlugTriageRouteImport.update({
    id: '/triage',
    path: '/triage',
    getParentRoute: () => AppWorkspaceSlugProjectSlugRouteRoute,
  } as any)
const AppWorkspaceSlugProjectSlugUpdatesRoute =
  AppWorkspaceSlugProjectSlugUpdatesRouteImport.update({
    id: '/updates',
    path: '/updates',
    getParentRoute: () => AppWorkspaceSlugProjectSlugRouteRoute,
  } as any)
const AppWorkspaceSlugSettingsIndexRoute =
  AppWorkspaceSlugSettingsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppWorkspaceSlugSettingsRouteRoute,
  } as any)
const AppWorkspaceSlugSettingsAccountRoute =
  AppWorkspaceSlugSettingsAccountRouteImport.update({
    id: '/account',
    path: '/account',
    getParentRoute: () => AppWorkspaceSlugSettingsRouteRoute,
  } as any)
const AppWorkspaceSlugSettingsAgentsRoute =
  AppWorkspaceSlugSettingsAgentsRouteImport.update({
    id: '/agents',
    path: '/agents',
    getParentRoute: () => AppWorkspaceSlugSettingsRouteRoute,
  } as any)
const AppWorkspaceSlugSettingsIntegrationsRoute =
  AppWorkspaceSlugSettingsIntegrationsRouteImport.update({
    id: '/integrations',
    path: '/integrations',
    getParentRoute: () => AppWorkspaceSlugSettingsRouteRoute,
  } as any)
const AppWorkspaceSlugSettingsMembersRoute =
  AppWorkspaceSlugSettingsMembersRouteImport.update({
    id: '/members',
    path: '/members',
    getParentRoute: () => AppWorkspaceSlugSettingsRouteRoute,
  } as any)
const AppWorkspaceSlugSettingsWorkspaceRoute =
  AppWorkspaceSlugSettingsWorkspaceRouteImport.update({
    id: '/workspace',
    path: '/workspace',
    getParentRoute: () => AppWorkspaceSlugSettingsRouteRoute,
  } as any)
const AppWorkspaceSlugProjectSlugDocumentsIndexRoute =
  AppWorkspaceSlugProjectSlugDocumentsIndexRouteImport.update({
    id: '/documents/',
    path: '/documents/',
    getParentRoute: () => AppWorkspaceSlugProjectSlugRouteRoute,
  } as any)
const AppWorkspaceSlugProjectSlugDocumentsDocumentIdRoute =
  AppWorkspaceSlugProjectSlugDocumentsDocumentIdRouteImport.update({
    id: '/documents/$documentId',
    path: '/documents/$documentId',
    getParentRoute: () => AppWorkspaceSlugProjectSlugRouteRoute,
  } as any)
const AppWorkspaceSlugProjectSlugIssuesIndexRoute =
  AppWorkspaceSlugProjectSlugIssuesIndexRouteImport.update({
    id: '/issues/',
    path: '/issues/',
    getParentRoute: () => AppWorkspaceSlugProjectSlugRouteRoute,
  } as any)
const AppWorkspaceSlugProjectSlugIssuesNumberRoute =
  AppWorkspaceSlugProjectSlugIssuesNumberRouteImport.update({
    id: '/issues/$number',
    path: '/issues/$number',
    getParentRoute: () => AppWorkspaceSlugProjectSlugRouteRoute,
  } as any)
const AppWorkspaceSlugProjectSlugTicketsIndexRoute =
  AppWorkspaceSlugProjectSlugTicketsIndexRouteImport.update({
    id: '/tickets/',
    path: '/tickets/',
    getParentRoute: () => AppWorkspaceSlugProjectSlugRouteRoute,
  } as any)
const AppWorkspaceSlugProjectSlugTicketsNumberRoute =
  AppWorkspaceSlugProjectSlugTicketsNumberRouteImport.update({
    id: '/tickets/$number',
    path: '/tickets/$number',
    getParentRoute: () => AppWorkspaceSlugProjectSlugRouteRoute,
  } as any)
const AppWorkspaceSlugSettingsProjectsIndexRoute =
  AppWorkspaceSlugSettingsProjectsIndexRouteImport.update({
    id: '/projects/',
    path: '/projects/',
    getParentRoute: () => AppWorkspaceSlugSettingsRouteRoute,
  } as any)
const AppWorkspaceSlugSettingsProjectsProjectSlugRoute =
  AppWorkspaceSlugSettingsProjectsProjectSlugRouteImport.update({
    id: '/projects/$projectSlug',
    path: '/projects/$projectSlug',
    getParentRoute: () => AppWorkspaceSlugSettingsRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/kit': typeof KitRoute
  '/reset-password': typeof ResetPasswordRoute
  '/$workspaceSlug': typeof AppWorkspaceSlugRouteRouteWithChildren
  '/new': typeof AppNewRoute
  '/forgot-password': typeof AuthForgotPasswordRoute
  '/login': typeof AuthLoginRoute
  '/signup': typeof AuthSignupRoute
  '/docs/$page': typeof DocsPageRoute
  '/github/callback': typeof GithubCallbackRoute
  '/invite/$invitationId': typeof InviteInvitationIdRoute
  '/slack/callback': typeof SlackCallbackRoute
  '/docs/': typeof DocsIndexRoute
  '/$workspaceSlug/$projectSlug': typeof AppWorkspaceSlugProjectSlugRouteRouteWithChildren
  '/$workspaceSlug/settings': typeof AppWorkspaceSlugSettingsRouteRouteWithChildren
  '/$workspaceSlug/board': typeof AppWorkspaceSlugBoardRoute
  '/$workspaceSlug/cycles': typeof AppWorkspaceSlugCyclesRoute
  '/$workspaceSlug/inbox': typeof AppWorkspaceSlugInboxRoute
  '/$workspaceSlug/my-issues': typeof AppWorkspaceSlugMyIssuesRoute
  '/$workspaceSlug/pulse': typeof AppWorkspaceSlugPulseRoute
  '/$workspaceSlug/stack': typeof AppWorkspaceSlugStackRoute
  '/$workspaceSlug/stats': typeof AppWorkspaceSlugStatsRoute
  '/$workspaceSlug/work': typeof AppWorkspaceSlugWorkRoute
  '/p/$slug/changelog': typeof PSlugChangelogRoute
  '/$workspaceSlug/': typeof AppWorkspaceSlugIndexRoute
  '/p/$slug/': typeof PSlugIndexRoute
  '/$workspaceSlug/$projectSlug/architecture': typeof AppWorkspaceSlugProjectSlugArchitectureRoute
  '/$workspaceSlug/$projectSlug/changelog': typeof AppWorkspaceSlugProjectSlugChangelogRoute
  '/$workspaceSlug/$projectSlug/experiments': typeof AppWorkspaceSlugProjectSlugExperimentsRoute
  '/$workspaceSlug/$projectSlug/pulls': typeof AppWorkspaceSlugProjectSlugPullsRoute
  '/$workspaceSlug/$projectSlug/ratings': typeof AppWorkspaceSlugProjectSlugRatingsRoute
  '/$workspaceSlug/$projectSlug/roadmap': typeof AppWorkspaceSlugProjectSlugRoadmapRoute
  '/$workspaceSlug/$projectSlug/triage': typeof AppWorkspaceSlugProjectSlugTriageRoute
  '/$workspaceSlug/$projectSlug/updates': typeof AppWorkspaceSlugProjectSlugUpdatesRoute
  '/$workspaceSlug/settings/account': typeof AppWorkspaceSlugSettingsAccountRoute
  '/$workspaceSlug/settings/agents': typeof AppWorkspaceSlugSettingsAgentsRoute
  '/$workspaceSlug/settings/integrations': typeof AppWorkspaceSlugSettingsIntegrationsRoute
  '/$workspaceSlug/settings/members': typeof AppWorkspaceSlugSettingsMembersRoute
  '/$workspaceSlug/settings/workspace': typeof AppWorkspaceSlugSettingsWorkspaceRoute
  '/$workspaceSlug/$projectSlug/': typeof AppWorkspaceSlugProjectSlugIndexRoute
  '/$workspaceSlug/settings/': typeof AppWorkspaceSlugSettingsIndexRoute
  '/$workspaceSlug/$projectSlug/documents/$documentId': typeof AppWorkspaceSlugProjectSlugDocumentsDocumentIdRoute
  '/$workspaceSlug/$projectSlug/issues/$number': typeof AppWorkspaceSlugProjectSlugIssuesNumberRoute
  '/$workspaceSlug/$projectSlug/tickets/$number': typeof AppWorkspaceSlugProjectSlugTicketsNumberRoute
  '/$workspaceSlug/settings/projects/$projectSlug': typeof AppWorkspaceSlugSettingsProjectsProjectSlugRoute
  '/$workspaceSlug/$projectSlug/documents/': typeof AppWorkspaceSlugProjectSlugDocumentsIndexRoute
  '/$workspaceSlug/$projectSlug/issues/': typeof AppWorkspaceSlugProjectSlugIssuesIndexRoute
  '/$workspaceSlug/$projectSlug/tickets/': typeof AppWorkspaceSlugProjectSlugTicketsIndexRoute
  '/$workspaceSlug/settings/projects/': typeof AppWorkspaceSlugSettingsProjectsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/kit': typeof KitRoute
  '/reset-password': typeof ResetPasswordRoute
  '/new': typeof AppNewRoute
  '/forgot-password': typeof AuthForgotPasswordRoute
  '/login': typeof AuthLoginRoute
  '/signup': typeof AuthSignupRoute
  '/docs/$page': typeof DocsPageRoute
  '/github/callback': typeof GithubCallbackRoute
  '/invite/$invitationId': typeof InviteInvitationIdRoute
  '/slack/callback': typeof SlackCallbackRoute
  '/docs': typeof DocsIndexRoute
  '/$workspaceSlug/board': typeof AppWorkspaceSlugBoardRoute
  '/$workspaceSlug/cycles': typeof AppWorkspaceSlugCyclesRoute
  '/$workspaceSlug/inbox': typeof AppWorkspaceSlugInboxRoute
  '/$workspaceSlug/my-issues': typeof AppWorkspaceSlugMyIssuesRoute
  '/$workspaceSlug/pulse': typeof AppWorkspaceSlugPulseRoute
  '/$workspaceSlug/stack': typeof AppWorkspaceSlugStackRoute
  '/$workspaceSlug/stats': typeof AppWorkspaceSlugStatsRoute
  '/$workspaceSlug/work': typeof AppWorkspaceSlugWorkRoute
  '/p/$slug/changelog': typeof PSlugChangelogRoute
  '/$workspaceSlug': typeof AppWorkspaceSlugIndexRoute
  '/p/$slug': typeof PSlugIndexRoute
  '/$workspaceSlug/$projectSlug/architecture': typeof AppWorkspaceSlugProjectSlugArchitectureRoute
  '/$workspaceSlug/$projectSlug/changelog': typeof AppWorkspaceSlugProjectSlugChangelogRoute
  '/$workspaceSlug/$projectSlug/experiments': typeof AppWorkspaceSlugProjectSlugExperimentsRoute
  '/$workspaceSlug/$projectSlug/pulls': typeof AppWorkspaceSlugProjectSlugPullsRoute
  '/$workspaceSlug/$projectSlug/ratings': typeof AppWorkspaceSlugProjectSlugRatingsRoute
  '/$workspaceSlug/$projectSlug/roadmap': typeof AppWorkspaceSlugProjectSlugRoadmapRoute
  '/$workspaceSlug/$projectSlug/triage': typeof AppWorkspaceSlugProjectSlugTriageRoute
  '/$workspaceSlug/$projectSlug/updates': typeof AppWorkspaceSlugProjectSlugUpdatesRoute
  '/$workspaceSlug/settings/account': typeof AppWorkspaceSlugSettingsAccountRoute
  '/$workspaceSlug/settings/agents': typeof AppWorkspaceSlugSettingsAgentsRoute
  '/$workspaceSlug/settings/integrations': typeof AppWorkspaceSlugSettingsIntegrationsRoute
  '/$workspaceSlug/settings/members': typeof AppWorkspaceSlugSettingsMembersRoute
  '/$workspaceSlug/settings/workspace': typeof AppWorkspaceSlugSettingsWorkspaceRoute
  '/$workspaceSlug/$projectSlug': typeof AppWorkspaceSlugProjectSlugIndexRoute
  '/$workspaceSlug/settings': typeof AppWorkspaceSlugSettingsIndexRoute
  '/$workspaceSlug/$projectSlug/documents/$documentId': typeof AppWorkspaceSlugProjectSlugDocumentsDocumentIdRoute
  '/$workspaceSlug/$projectSlug/issues/$number': typeof AppWorkspaceSlugProjectSlugIssuesNumberRoute
  '/$workspaceSlug/$projectSlug/tickets/$number': typeof AppWorkspaceSlugProjectSlugTicketsNumberRoute
  '/$workspaceSlug/settings/projects/$projectSlug': typeof AppWorkspaceSlugSettingsProjectsProjectSlugRoute
  '/$workspaceSlug/$projectSlug/documents': typeof AppWorkspaceSlugProjectSlugDocumentsIndexRoute
  '/$workspaceSlug/$projectSlug/issues': typeof AppWorkspaceSlugProjectSlugIssuesIndexRoute
  '/$workspaceSlug/$projectSlug/tickets': typeof AppWorkspaceSlugProjectSlugTicketsIndexRoute
  '/$workspaceSlug/settings/projects': typeof AppWorkspaceSlugSettingsProjectsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_app': typeof AppRouteRouteWithChildren
  '/_auth': typeof AuthRouteRouteWithChildren
  '/kit': typeof KitRoute
  '/reset-password': typeof ResetPasswordRoute
  '/_app/$workspaceSlug': typeof AppWorkspaceSlugRouteRouteWithChildren
  '/_app/new': typeof AppNewRoute
  '/_auth/forgot-password': typeof AuthForgotPasswordRoute
  '/_auth/login': typeof AuthLoginRoute
  '/_auth/signup': typeof AuthSignupRoute
  '/docs/$page': typeof DocsPageRoute
  '/github/callback': typeof GithubCallbackRoute
  '/invite/$invitationId': typeof InviteInvitationIdRoute
  '/slack/callback': typeof SlackCallbackRoute
  '/docs/': typeof DocsIndexRoute
  '/_app/$workspaceSlug/$projectSlug': typeof AppWorkspaceSlugProjectSlugRouteRouteWithChildren
  '/_app/$workspaceSlug/settings': typeof AppWorkspaceSlugSettingsRouteRouteWithChildren
  '/_app/$workspaceSlug/board': typeof AppWorkspaceSlugBoardRoute
  '/_app/$workspaceSlug/cycles': typeof AppWorkspaceSlugCyclesRoute
  '/_app/$workspaceSlug/inbox': typeof AppWorkspaceSlugInboxRoute
  '/_app/$workspaceSlug/my-issues': typeof AppWorkspaceSlugMyIssuesRoute
  '/_app/$workspaceSlug/pulse': typeof AppWorkspaceSlugPulseRoute
  '/_app/$workspaceSlug/stack': typeof AppWorkspaceSlugStackRoute
  '/_app/$workspaceSlug/stats': typeof AppWorkspaceSlugStatsRoute
  '/_app/$workspaceSlug/work': typeof AppWorkspaceSlugWorkRoute
  '/p/$slug/changelog': typeof PSlugChangelogRoute
  '/_app/$workspaceSlug/': typeof AppWorkspaceSlugIndexRoute
  '/p/$slug/': typeof PSlugIndexRoute
  '/_app/$workspaceSlug/$projectSlug/architecture': typeof AppWorkspaceSlugProjectSlugArchitectureRoute
  '/_app/$workspaceSlug/$projectSlug/changelog': typeof AppWorkspaceSlugProjectSlugChangelogRoute
  '/_app/$workspaceSlug/$projectSlug/experiments': typeof AppWorkspaceSlugProjectSlugExperimentsRoute
  '/_app/$workspaceSlug/$projectSlug/pulls': typeof AppWorkspaceSlugProjectSlugPullsRoute
  '/_app/$workspaceSlug/$projectSlug/ratings': typeof AppWorkspaceSlugProjectSlugRatingsRoute
  '/_app/$workspaceSlug/$projectSlug/roadmap': typeof AppWorkspaceSlugProjectSlugRoadmapRoute
  '/_app/$workspaceSlug/$projectSlug/triage': typeof AppWorkspaceSlugProjectSlugTriageRoute
  '/_app/$workspaceSlug/$projectSlug/updates': typeof AppWorkspaceSlugProjectSlugUpdatesRoute
  '/_app/$workspaceSlug/settings/account': typeof AppWorkspaceSlugSettingsAccountRoute
  '/_app/$workspaceSlug/settings/agents': typeof AppWorkspaceSlugSettingsAgentsRoute
  '/_app/$workspaceSlug/settings/integrations': typeof AppWorkspaceSlugSettingsIntegrationsRoute
  '/_app/$workspaceSlug/settings/members': typeof AppWorkspaceSlugSettingsMembersRoute
  '/_app/$workspaceSlug/settings/workspace': typeof AppWorkspaceSlugSettingsWorkspaceRoute
  '/_app/$workspaceSlug/$projectSlug/': typeof AppWorkspaceSlugProjectSlugIndexRoute
  '/_app/$workspaceSlug/settings/': typeof AppWorkspaceSlugSettingsIndexRoute
  '/_app/$workspaceSlug/$projectSlug/documents/$documentId': typeof AppWorkspaceSlugProjectSlugDocumentsDocumentIdRoute
  '/_app/$workspaceSlug/$projectSlug/issues/$number': typeof AppWorkspaceSlugProjectSlugIssuesNumberRoute
  '/_app/$workspaceSlug/$projectSlug/tickets/$number': typeof AppWorkspaceSlugProjectSlugTicketsNumberRoute
  '/_app/$workspaceSlug/settings/projects/$projectSlug': typeof AppWorkspaceSlugSettingsProjectsProjectSlugRoute
  '/_app/$workspaceSlug/$projectSlug/documents/': typeof AppWorkspaceSlugProjectSlugDocumentsIndexRoute
  '/_app/$workspaceSlug/$projectSlug/issues/': typeof AppWorkspaceSlugProjectSlugIssuesIndexRoute
  '/_app/$workspaceSlug/$projectSlug/tickets/': typeof AppWorkspaceSlugProjectSlugTicketsIndexRoute
  '/_app/$workspaceSlug/settings/projects/': typeof AppWorkspaceSlugSettingsProjectsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/kit'
    | '/reset-password'
    | '/$workspaceSlug'
    | '/new'
    | '/forgot-password'
    | '/login'
    | '/signup'
    | '/docs/$page'
    | '/github/callback'
    | '/invite/$invitationId'
    | '/slack/callback'
    | '/docs/'
    | '/$workspaceSlug/$projectSlug'
    | '/$workspaceSlug/settings'
    | '/$workspaceSlug/board'
    | '/$workspaceSlug/cycles'
    | '/$workspaceSlug/inbox'
    | '/$workspaceSlug/my-issues'
    | '/$workspaceSlug/pulse'
    | '/$workspaceSlug/stack'
    | '/$workspaceSlug/stats'
    | '/$workspaceSlug/work'
    | '/p/$slug/changelog'
    | '/$workspaceSlug/'
    | '/p/$slug/'
    | '/$workspaceSlug/$projectSlug/architecture'
    | '/$workspaceSlug/$projectSlug/changelog'
    | '/$workspaceSlug/$projectSlug/experiments'
    | '/$workspaceSlug/$projectSlug/pulls'
    | '/$workspaceSlug/$projectSlug/ratings'
    | '/$workspaceSlug/$projectSlug/roadmap'
    | '/$workspaceSlug/$projectSlug/triage'
    | '/$workspaceSlug/$projectSlug/updates'
    | '/$workspaceSlug/settings/account'
    | '/$workspaceSlug/settings/agents'
    | '/$workspaceSlug/settings/integrations'
    | '/$workspaceSlug/settings/members'
    | '/$workspaceSlug/settings/workspace'
    | '/$workspaceSlug/$projectSlug/'
    | '/$workspaceSlug/settings/'
    | '/$workspaceSlug/$projectSlug/documents/$documentId'
    | '/$workspaceSlug/$projectSlug/issues/$number'
    | '/$workspaceSlug/$projectSlug/tickets/$number'
    | '/$workspaceSlug/settings/projects/$projectSlug'
    | '/$workspaceSlug/$projectSlug/documents/'
    | '/$workspaceSlug/$projectSlug/issues/'
    | '/$workspaceSlug/$projectSlug/tickets/'
    | '/$workspaceSlug/settings/projects/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/kit'
    | '/reset-password'
    | '/new'
    | '/forgot-password'
    | '/login'
    | '/signup'
    | '/docs/$page'
    | '/github/callback'
    | '/invite/$invitationId'
    | '/slack/callback'
    | '/docs'
    | '/$workspaceSlug/board'
    | '/$workspaceSlug/cycles'
    | '/$workspaceSlug/inbox'
    | '/$workspaceSlug/my-issues'
    | '/$workspaceSlug/pulse'
    | '/$workspaceSlug/stack'
    | '/$workspaceSlug/stats'
    | '/$workspaceSlug/work'
    | '/p/$slug/changelog'
    | '/$workspaceSlug'
    | '/p/$slug'
    | '/$workspaceSlug/$projectSlug/architecture'
    | '/$workspaceSlug/$projectSlug/changelog'
    | '/$workspaceSlug/$projectSlug/experiments'
    | '/$workspaceSlug/$projectSlug/pulls'
    | '/$workspaceSlug/$projectSlug/ratings'
    | '/$workspaceSlug/$projectSlug/roadmap'
    | '/$workspaceSlug/$projectSlug/triage'
    | '/$workspaceSlug/$projectSlug/updates'
    | '/$workspaceSlug/settings/account'
    | '/$workspaceSlug/settings/agents'
    | '/$workspaceSlug/settings/integrations'
    | '/$workspaceSlug/settings/members'
    | '/$workspaceSlug/settings/workspace'
    | '/$workspaceSlug/$projectSlug'
    | '/$workspaceSlug/settings'
    | '/$workspaceSlug/$projectSlug/documents/$documentId'
    | '/$workspaceSlug/$projectSlug/issues/$number'
    | '/$workspaceSlug/$projectSlug/tickets/$number'
    | '/$workspaceSlug/settings/projects/$projectSlug'
    | '/$workspaceSlug/$projectSlug/documents'
    | '/$workspaceSlug/$projectSlug/issues'
    | '/$workspaceSlug/$projectSlug/tickets'
    | '/$workspaceSlug/settings/projects'
  id:
    | '__root__'
    | '/'
    | '/_app'
    | '/_auth'
    | '/kit'
    | '/reset-password'
    | '/_app/$workspaceSlug'
    | '/_app/new'
    | '/_auth/forgot-password'
    | '/_auth/login'
    | '/_auth/signup'
    | '/docs/$page'
    | '/github/callback'
    | '/invite/$invitationId'
    | '/slack/callback'
    | '/docs/'
    | '/_app/$workspaceSlug/$projectSlug'
    | '/_app/$workspaceSlug/settings'
    | '/_app/$workspaceSlug/board'
    | '/_app/$workspaceSlug/cycles'
    | '/_app/$workspaceSlug/inbox'
    | '/_app/$workspaceSlug/my-issues'
    | '/_app/$workspaceSlug/pulse'
    | '/_app/$workspaceSlug/stack'
    | '/_app/$workspaceSlug/stats'
    | '/_app/$workspaceSlug/work'
    | '/p/$slug/changelog'
    | '/_app/$workspaceSlug/'
    | '/p/$slug/'
    | '/_app/$workspaceSlug/$projectSlug/architecture'
    | '/_app/$workspaceSlug/$projectSlug/changelog'
    | '/_app/$workspaceSlug/$projectSlug/experiments'
    | '/_app/$workspaceSlug/$projectSlug/pulls'
    | '/_app/$workspaceSlug/$projectSlug/ratings'
    | '/_app/$workspaceSlug/$projectSlug/roadmap'
    | '/_app/$workspaceSlug/$projectSlug/triage'
    | '/_app/$workspaceSlug/$projectSlug/updates'
    | '/_app/$workspaceSlug/settings/account'
    | '/_app/$workspaceSlug/settings/agents'
    | '/_app/$workspaceSlug/settings/integrations'
    | '/_app/$workspaceSlug/settings/members'
    | '/_app/$workspaceSlug/settings/workspace'
    | '/_app/$workspaceSlug/$projectSlug/'
    | '/_app/$workspaceSlug/settings/'
    | '/_app/$workspaceSlug/$projectSlug/documents/$documentId'
    | '/_app/$workspaceSlug/$projectSlug/issues/$number'
    | '/_app/$workspaceSlug/$projectSlug/tickets/$number'
    | '/_app/$workspaceSlug/settings/projects/$projectSlug'
    | '/_app/$workspaceSlug/$projectSlug/documents/'
    | '/_app/$workspaceSlug/$projectSlug/issues/'
    | '/_app/$workspaceSlug/$projectSlug/tickets/'
    | '/_app/$workspaceSlug/settings/projects/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRouteRoute: typeof AppRouteRouteWithChildren
  AuthRouteRoute: typeof AuthRouteRouteWithChildren
  KitRoute: typeof KitRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  DocsPageRoute: typeof DocsPageRoute
  GithubCallbackRoute: typeof GithubCallbackRoute
  InviteInvitationIdRoute: typeof InviteInvitationIdRoute
  SlackCallbackRoute: typeof SlackCallbackRoute
  DocsIndexRoute: typeof DocsIndexRoute
  PSlugChangelogRoute: typeof PSlugChangelogRoute
  PSlugIndexRoute: typeof PSlugIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/kit': {
      id: '/kit'
      path: '/kit'
      fullPath: '/kit'
      preLoaderRoute: typeof KitRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/$workspaceSlug': {
      id: '/_app/$workspaceSlug'
      path: '/$workspaceSlug'
      fullPath: '/$workspaceSlug'
      preLoaderRoute: typeof AppWorkspaceSlugRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/new': {
      id: '/_app/new'
      path: '/new'
      fullPath: '/new'
      preLoaderRoute: typeof AppNewRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_auth/forgot-password': {
      id: '/_auth/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof AuthForgotPasswordRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/login': {
      id: '/_auth/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof AuthLoginRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/signup': {
      id: '/_auth/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof AuthSignupRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/docs/': {
      id: '/docs/'
      path: '/docs'
      fullPath: '/docs/'
      preLoaderRoute: typeof DocsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/docs/$page': {
      id: '/docs/$page'
      path: '/docs/$page'
      fullPath: '/docs/$page'
      preLoaderRoute: typeof DocsPageRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/github/callback': {
      id: '/github/callback'
      path: '/github/callback'
      fullPath: '/github/callback'
      preLoaderRoute: typeof GithubCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invite/$invitationId': {
      id: '/invite/$invitationId'
      path: '/invite/$invitationId'
      fullPath: '/invite/$invitationId'
      preLoaderRoute: typeof InviteInvitationIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/slack/callback': {
      id: '/slack/callback'
      path: '/slack/callback'
      fullPath: '/slack/callback'
      preLoaderRoute: typeof SlackCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/$workspaceSlug/': {
      id: '/_app/$workspaceSlug/'
      path: '/'
      fullPath: '/$workspaceSlug/'
      preLoaderRoute: typeof AppWorkspaceSlugIndexRouteImport
      parentRoute: typeof AppWorkspaceSlugRouteRoute
    }
    '/_app/$workspaceSlug/$projectSlug': {
      id: '/_app/$workspaceSlug/$projectSlug'
      path: '/$projectSlug'
      fullPath: '/$workspaceSlug/$projectSlug'
      preLoaderRoute: typeof AppWorkspaceSlugProjectSlugRouteRouteImport
      parentRoute: typeof AppWorkspaceSlugRouteRoute
    }
    '/_app/$workspaceSlug/board': {
      id: '/_app/$workspaceSlug/board'
      path: '/board'
      fullPath: '/$workspaceSlug/board'
      preLoaderRoute: typeof AppWorkspaceSlugBoardRouteImport
      parentRoute: typeof AppWorkspaceSlugRouteRoute
    }
    '/_app/$workspaceSlug/cycles': {
      id: '/_app/$workspaceSlug/cycles'
      path: '/cycles'
      fullPath: '/$workspaceSlug/cycles'
      preLoaderRoute: typeof AppWorkspaceSlugCyclesRouteImport
      parentRoute: typeof AppWorkspaceSlugRouteRoute
    }
    '/_app/$workspaceSlug/inbox': {
      id: '/_app/$workspaceSlug/inbox'
      path: '/inbox'
      fullPath: '/$workspaceSlug/inbox'
      preLoaderRoute: typeof AppWorkspaceSlugInboxRouteImport
      parentRoute: typeof AppWorkspaceSlugRouteRoute
    }
    '/_app/$workspaceSlug/my-issues': {
      id: '/_app/$workspaceSlug/my-issues'
      path: '/my-issues'
      fullPath: '/$workspaceSlug/my-issues'
      preLoaderRoute: typeof AppWorkspaceSlugMyIssuesRouteImport
      parentRoute: typeof AppWorkspaceSlugRouteRoute
    }
    '/_app/$workspaceSlug/pulse': {
      id: '/_app/$workspaceSlug/pulse'
      path: '/pulse'
      fullPath: '/$workspaceSlug/pulse'
      preLoaderRoute: typeof AppWorkspaceSlugPulseRouteImport
      parentRoute: typeof AppWorkspaceSlugRouteRoute
    }
    '/_app/$workspaceSlug/settings': {
      id: '/_app/$workspaceSlug/settings'
      path: '/settings'
      fullPath: '/$workspaceSlug/settings'
      preLoaderRoute: typeof AppWorkspaceSlugSettingsRouteRouteImport
      parentRoute: typeof AppWorkspaceSlugRouteRoute
    }
    '/_app/$workspaceSlug/stack': {
      id: '/_app/$workspaceSlug/stack'
      path: '/stack'
      fullPath: '/$workspaceSlug/stack'
      preLoaderRoute: typeof AppWorkspaceSlugStackRouteImport
      parentRoute: typeof AppWorkspaceSlugRouteRoute
    }
    '/_app/$workspaceSlug/stats': {
      id: '/_app/$workspaceSlug/stats'
      path: '/stats'
      fullPath: '/$workspaceSlug/stats'
      preLoaderRoute: typeof AppWorkspaceSlugStatsRouteImport
      parentRoute: typeof AppWorkspaceSlugRouteRoute
    }
    '/_app/$workspaceSlug/work': {
      id: '/_app/$workspaceSlug/work'
      path: '/work'
      fullPath: '/$workspaceSlug/work'
      preLoaderRoute: typeof AppWorkspaceSlugWorkRouteImport
      parentRoute: typeof AppWorkspaceSlugRouteRoute
    }
    '/p/$slug/': {
      id: '/p/$slug/'
      path: '/p/$slug'
      fullPath: '/p/$slug/'
      preLoaderRoute: typeof PSlugIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/p/$slug/changelog': {
      id: '/p/$slug/changelog'
      path: '/p/$slug/changelog'
      fullPath: '/p/$slug/changelog'
      preLoaderRoute: typeof PSlugChangelogRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/$workspaceSlug/$projectSlug/': {
      id: '/_app/$workspaceSlug/$projectSlug/'
      path: '/'
      fullPath: '/$workspaceSlug/$projectSlug/'
      preLoaderRoute: typeof AppWorkspaceSlugProjectSlugIndexRouteImport
      parentRoute: typeof AppWorkspaceSlugProjectSlugRouteRoute
    }
    '/_app/$workspaceSlug/$projectSlug/architecture': {
      id: '/_app/$workspaceSlug/$projectSlug/architecture'
      path: '/architecture'
      fullPath: '/$workspaceSlug/$projectSlug/architecture'
      preLoaderRoute: typeof AppWorkspaceSlugProjectSlugArchitectureRouteImport
      parentRoute: typeof AppWorkspaceSlugProjectSlugRouteRoute
    }
    '/_app/$workspaceSlug/$projectSlug/changelog': {
      id: '/_app/$workspaceSlug/$projectSlug/changelog'
      path: '/changelog'
      fullPath: '/$workspaceSlug/$projectSlug/changelog'
      preLoaderRoute: typeof AppWorkspaceSlugProjectSlugChangelogRouteImport
      parentRoute: typeof AppWorkspaceSlugProjectSlugRouteRoute
    }
    '/_app/$workspaceSlug/$projectSlug/experiments': {
      id: '/_app/$workspaceSlug/$projectSlug/experiments'
      path: '/experiments'
      fullPath: '/$workspaceSlug/$projectSlug/experiments'
      preLoaderRoute: typeof AppWorkspaceSlugProjectSlugExperimentsRouteImport
      parentRoute: typeof AppWorkspaceSlugProjectSlugRouteRoute
    }
    '/_app/$workspaceSlug/$projectSlug/pulls': {
      id: '/_app/$workspaceSlug/$projectSlug/pulls'
      path: '/pulls'
      fullPath: '/$workspaceSlug/$projectSlug/pulls'
      preLoaderRoute: typeof AppWorkspaceSlugProjectSlugPullsRouteImport
      parentRoute: typeof AppWorkspaceSlugProjectSlugRouteRoute
    }
    '/_app/$workspaceSlug/$projectSlug/ratings': {
      id: '/_app/$workspaceSlug/$projectSlug/ratings'
      path: '/ratings'
      fullPath: '/$workspaceSlug/$projectSlug/ratings'
      preLoaderRoute: typeof AppWorkspaceSlugProjectSlugRatingsRouteImport
      parentRoute: typeof AppWorkspaceSlugProjectSlugRouteRoute
    }
    '/_app/$workspaceSlug/$projectSlug/roadmap': {
      id: '/_app/$workspaceSlug/$projectSlug/roadmap'
      path: '/roadmap'
      fullPath: '/$workspaceSlug/$projectSlug/roadmap'
      preLoaderRoute: typeof AppWorkspaceSlugProjectSlugRoadmapRouteImport
      parentRoute: typeof AppWorkspaceSlugProjectSlugRouteRoute
    }
    '/_app/$workspaceSlug/$projectSlug/triage': {
      id: '/_app/$workspaceSlug/$projectSlug/triage'
      path: '/triage'
      fullPath: '/$workspaceSlug/$projectSlug/triage'
      preLoaderRoute: typeof AppWorkspaceSlugProjectSlugTriageRouteImport
      parentRoute: typeof AppWorkspaceSlugProjectSlugRouteRoute
    }
    '/_app/$workspaceSlug/$projectSlug/updates': {
      id: '/_app/$workspaceSlug/$projectSlug/updates'
      path: '/updates'
      fullPath: '/$workspaceSlug/$projectSlug/updates'
      preLoaderRoute: typeof AppWorkspaceSlugProjectSlugUpdatesRouteImport
      parentRoute: typeof AppWorkspaceSlugProjectSlugRouteRoute
    }
    '/_app/$workspaceSlug/settings/': {
      id: '/_app/$workspaceSlug/settings/'
      path: '/'
      fullPath: '/$workspaceSlug/settings/'
      preLoaderRoute: typeof AppWorkspaceSlugSettingsIndexRouteImport
      parentRoute: typeof AppWorkspaceSlugSettingsRouteRoute
    }
    '/_app/$workspaceSlug/settings/account': {
      id: '/_app/$workspaceSlug/settings/account'
      path: '/account'
      fullPath: '/$workspaceSlug/settings/account'
      preLoaderRoute: typeof AppWorkspaceSlugSettingsAccountRouteImport
      parentRoute: typeof AppWorkspaceSlugSettingsRouteRoute
    }
    '/_app/$workspaceSlug/settings/agents': {
      id: '/_app/$workspaceSlug/settings/agents'
      path: '/agents'
      fullPath: '/$workspaceSlug/settings/agents'
      preLoaderRoute: typeof AppWorkspaceSlugSettingsAgentsRouteImport
      parentRoute: typeof AppWorkspaceSlugSettingsRouteRoute
    }
    '/_app/$workspaceSlug/settings/integrations': {
      id: '/_app/$workspaceSlug/settings/integrations'
      path: '/integrations'
      fullPath: '/$workspaceSlug/settings/integrations'
      preLoaderRoute: typeof AppWorkspaceSlugSettingsIntegrationsRouteImport
      parentRoute: typeof AppWorkspaceSlugSettingsRouteRoute
    }
    '/_app/$workspaceSlug/settings/members': {
      id: '/_app/$workspaceSlug/settings/members'
      path: '/members'
      fullPath: '/$workspaceSlug/settings/members'
      preLoaderRoute: typeof AppWorkspaceSlugSettingsMembersRouteImport
      parentRoute: typeof AppWorkspaceSlugSettingsRouteRoute
    }
    '/_app/$workspaceSlug/settings/workspace': {
      id: '/_app/$workspaceSlug/settings/workspace'
      path: '/workspace'
      fullPath: '/$workspaceSlug/settings/workspace'
      preLoaderRoute: typeof AppWorkspaceSlugSettingsWorkspaceRouteImport
      parentRoute: typeof AppWorkspaceSlugSettingsRouteRoute
    }
    '/_app/$workspaceSlug/$projectSlug/documents/': {
      id: '/_app/$workspaceSlug/$projectSlug/documents/'
      path: '/documents'
      fullPath: '/$workspaceSlug/$projectSlug/documents/'
      preLoaderRoute: typeof AppWorkspaceSlugProjectSlugDocumentsIndexRouteImport
      parentRoute: typeof AppWorkspaceSlugProjectSlugRouteRoute
    }
    '/_app/$workspaceSlug/$projectSlug/documents/$documentId': {
      id: '/_app/$workspaceSlug/$projectSlug/documents/$documentId'
      path: '/documents/$documentId'
      fullPath: '/$workspaceSlug/$projectSlug/documents/$documentId'
      preLoaderRoute: typeof AppWorkspaceSlugProjectSlugDocumentsDocumentIdRouteImport
      parentRoute: typeof AppWorkspaceSlugProjectSlugRouteRoute
    }
    '/_app/$workspaceSlug/$projectSlug/issues/': {
      id: '/_app/$workspaceSlug/$projectSlug/issues/'
      path: '/issues'
      fullPath: '/$workspaceSlug/$projectSlug/issues/'
      preLoaderRoute: typeof AppWorkspaceSlugProjectSlugIssuesIndexRouteImport
      parentRoute: typeof AppWorkspaceSlugProjectSlugRouteRoute
    }
    '/_app/$workspaceSlug/$projectSlug/issues/$number': {
      id: '/_app/$workspaceSlug/$projectSlug/issues/$number'
      path: '/issues/$number'
      fullPath: '/$workspaceSlug/$projectSlug/issues/$number'
      preLoaderRoute: typeof AppWorkspaceSlugProjectSlugIssuesNumberRouteImport
      parentRoute: typeof AppWorkspaceSlugProjectSlugRouteRoute
    }
    '/_app/$workspaceSlug/$projectSlug/tickets/': {
      id: '/_app/$workspaceSlug/$projectSlug/tickets/'
      path: '/tickets'
      fullPath: '/$workspaceSlug/$projectSlug/tickets/'
      preLoaderRoute: typeof AppWorkspaceSlugProjectSlugTicketsIndexRouteImport
      parentRoute: typeof AppWorkspaceSlugProjectSlugRouteRoute
    }
    '/_app/$workspaceSlug/$projectSlug/tickets/$number': {
      id: '/_app/$workspaceSlug/$projectSlug/tickets/$number'
      path: '/tickets/$number'
      fullPath: '/$workspaceSlug/$projectSlug/tickets/$number'
      preLoaderRoute: typeof AppWorkspaceSlugProjectSlugTicketsNumberRouteImport
      parentRoute: typeof AppWorkspaceSlugProjectSlugRouteRoute
    }
    '/_app/$workspaceSlug/settings/projects/': {
      id: '/_app/$workspaceSlug/settings/projects/'
      path: '/projects'
      fullPath: '/$workspaceSlug/settings/projects/'
      preLoaderRoute: typeof AppWorkspaceSlugSettingsProjectsIndexRouteImport
      parentRoute: typeof AppWorkspaceSlugSettingsRouteRoute
    }
    '/_app/$workspaceSlug/settings/projects/$projectSlug': {
      id: '/_app/$workspaceSlug/settings/projects/$projectSlug'
      path: '/projects/$projectSlug'
      fullPath: '/$workspaceSlug/settings/projects/$projectSlug'
      preLoaderRoute: typeof AppWorkspaceSlugSettingsProjectsProjectSlugRouteImport
      parentRoute: typeof AppWorkspaceSlugSettingsRouteRoute
    }
  }
}

interface AppWorkspaceSlugProjectSlugRouteRouteChildren {
  AppWorkspaceSlugProjectSlugArchitectureRoute: typeof AppWorkspaceSlugProjectSlugArchitectureRoute
  AppWorkspaceSlugProjectSlugChangelogRoute: typeof AppWorkspaceSlugProjectSlugChangelogRoute
  AppWorkspaceSlugProjectSlugExperimentsRoute: typeof AppWorkspaceSlugProjectSlugExperimentsRoute
  AppWorkspaceSlugProjectSlugPullsRoute: typeof AppWorkspaceSlugProjectSlugPullsRoute
  AppWorkspaceSlugProjectSlugRatingsRoute: typeof AppWorkspaceSlugProjectSlugRatingsRoute
  AppWorkspaceSlugProjectSlugRoadmapRoute: typeof AppWorkspaceSlugProjectSlugRoadmapRoute
  AppWorkspaceSlugProjectSlugTriageRoute: typeof AppWorkspaceSlugProjectSlugTriageRoute
  AppWorkspaceSlugProjectSlugUpdatesRoute: typeof AppWorkspaceSlugProjectSlugUpdatesRoute
  AppWorkspaceSlugProjectSlugIndexRoute: typeof AppWorkspaceSlugProjectSlugIndexRoute
  AppWorkspaceSlugProjectSlugDocumentsDocumentIdRoute: typeof AppWorkspaceSlugProjectSlugDocumentsDocumentIdRoute
  AppWorkspaceSlugProjectSlugIssuesNumberRoute: typeof AppWorkspaceSlugProjectSlugIssuesNumberRoute
  AppWorkspaceSlugProjectSlugTicketsNumberRoute: typeof AppWorkspaceSlugProjectSlugTicketsNumberRoute
  AppWorkspaceSlugProjectSlugDocumentsIndexRoute: typeof AppWorkspaceSlugProjectSlugDocumentsIndexRoute
  AppWorkspaceSlugProjectSlugIssuesIndexRoute: typeof AppWorkspaceSlugProjectSlugIssuesIndexRoute
  AppWorkspaceSlugProjectSlugTicketsIndexRoute: typeof AppWorkspaceSlugProjectSlugTicketsIndexRoute
}

const AppWorkspaceSlugProjectSlugRouteRouteChildren: AppWorkspaceSlugProjectSlugRouteRouteChildren =
  {
    AppWorkspaceSlugProjectSlugArchitectureRoute:
      AppWorkspaceSlugProjectSlugArchitectureRoute,
    AppWorkspaceSlugProjectSlugChangelogRoute:
      AppWorkspaceSlugProjectSlugChangelogRoute,
    AppWorkspaceSlugProjectSlugExperimentsRoute:
      AppWorkspaceSlugProjectSlugExperimentsRoute,
    AppWorkspaceSlugProjectSlugPullsRoute:
      AppWorkspaceSlugProjectSlugPullsRoute,
    AppWorkspaceSlugProjectSlugRatingsRoute:
      AppWorkspaceSlugProjectSlugRatingsRoute,
    AppWorkspaceSlugProjectSlugRoadmapRoute:
      AppWorkspaceSlugProjectSlugRoadmapRoute,
    AppWorkspaceSlugProjectSlugTriageRoute:
      AppWorkspaceSlugProjectSlugTriageRoute,
    AppWorkspaceSlugProjectSlugUpdatesRoute:
      AppWorkspaceSlugProjectSlugUpdatesRoute,
    AppWorkspaceSlugProjectSlugIndexRoute:
      AppWorkspaceSlugProjectSlugIndexRoute,
    AppWorkspaceSlugProjectSlugDocumentsDocumentIdRoute:
      AppWorkspaceSlugProjectSlugDocumentsDocumentIdRoute,
    AppWorkspaceSlugProjectSlugIssuesNumberRoute:
      AppWorkspaceSlugProjectSlugIssuesNumberRoute,
    AppWorkspaceSlugProjectSlugTicketsNumberRoute:
      AppWorkspaceSlugProjectSlugTicketsNumberRoute,
    AppWorkspaceSlugProjectSlugDocumentsIndexRoute:
      AppWorkspaceSlugProjectSlugDocumentsIndexRoute,
    AppWorkspaceSlugProjectSlugIssuesIndexRoute:
      AppWorkspaceSlugProjectSlugIssuesIndexRoute,
    AppWorkspaceSlugProjectSlugTicketsIndexRoute:
      AppWorkspaceSlugProjectSlugTicketsIndexRoute,
  }

const AppWorkspaceSlugProjectSlugRouteRouteWithChildren =
  AppWorkspaceSlugProjectSlugRouteRoute._addFileChildren(
    AppWorkspaceSlugProjectSlugRouteRouteChildren,
  )

interface AppWorkspaceSlugSettingsRouteRouteChildren {
  AppWorkspaceSlugSettingsAccountRoute: typeof AppWorkspaceSlugSettingsAccountRoute
  AppWorkspaceSlugSettingsAgentsRoute: typeof AppWorkspaceSlugSettingsAgentsRoute
  AppWorkspaceSlugSettingsIntegrationsRoute: typeof AppWorkspaceSlugSettingsIntegrationsRoute
  AppWorkspaceSlugSettingsMembersRoute: typeof AppWorkspaceSlugSettingsMembersRoute
  AppWorkspaceSlugSettingsWorkspaceRoute: typeof AppWorkspaceSlugSettingsWorkspaceRoute
  AppWorkspaceSlugSettingsIndexRoute: typeof AppWorkspaceSlugSettingsIndexRoute
  AppWorkspaceSlugSettingsProjectsProjectSlugRoute: typeof AppWorkspaceSlugSettingsProjectsProjectSlugRoute
  AppWorkspaceSlugSettingsProjectsIndexRoute: typeof AppWorkspaceSlugSettingsProjectsIndexRoute
}

const AppWorkspaceSlugSettingsRouteRouteChildren: AppWorkspaceSlugSettingsRouteRouteChildren =
  {
    AppWorkspaceSlugSettingsAccountRoute: AppWorkspaceSlugSettingsAccountRoute,
    AppWorkspaceSlugSettingsAgentsRoute: AppWorkspaceSlugSettingsAgentsRoute,
    AppWorkspaceSlugSettingsIntegrationsRoute:
      AppWorkspaceSlugSettingsIntegrationsRoute,
    AppWorkspaceSlugSettingsMembersRoute: AppWorkspaceSlugSettingsMembersRoute,
    AppWorkspaceSlugSettingsWorkspaceRoute:
      AppWorkspaceSlugSettingsWorkspaceRoute,
    AppWorkspaceSlugSettingsIndexRoute: AppWorkspaceSlugSettingsIndexRoute,
    AppWorkspaceSlugSettingsProjectsProjectSlugRoute:
      AppWorkspaceSlugSettingsProjectsProjectSlugRoute,
    AppWorkspaceSlugSettingsProjectsIndexRoute:
      AppWorkspaceSlugSettingsProjectsIndexRoute,
  }

const AppWorkspaceSlugSettingsRouteRouteWithChildren =
  AppWorkspaceSlugSettingsRouteRoute._addFileChildren(
    AppWorkspaceSlugSettingsRouteRouteChildren,
  )

interface AppWorkspaceSlugRouteRouteChildren {
  AppWorkspaceSlugProjectSlugRouteRoute: typeof AppWorkspaceSlugProjectSlugRouteRouteWithChildren
  AppWorkspaceSlugSettingsRouteRoute: typeof AppWorkspaceSlugSettingsRouteRouteWithChildren
  AppWorkspaceSlugBoardRoute: typeof AppWorkspaceSlugBoardRoute
  AppWorkspaceSlugCyclesRoute: typeof AppWorkspaceSlugCyclesRoute
  AppWorkspaceSlugInboxRoute: typeof AppWorkspaceSlugInboxRoute
  AppWorkspaceSlugMyIssuesRoute: typeof AppWorkspaceSlugMyIssuesRoute
  AppWorkspaceSlugPulseRoute: typeof AppWorkspaceSlugPulseRoute
  AppWorkspaceSlugStackRoute: typeof AppWorkspaceSlugStackRoute
  AppWorkspaceSlugStatsRoute: typeof AppWorkspaceSlugStatsRoute
  AppWorkspaceSlugWorkRoute: typeof AppWorkspaceSlugWorkRoute
  AppWorkspaceSlugIndexRoute: typeof AppWorkspaceSlugIndexRoute
}

const AppWorkspaceSlugRouteRouteChildren: AppWorkspaceSlugRouteRouteChildren = {
  AppWorkspaceSlugProjectSlugRouteRoute:
    AppWorkspaceSlugProjectSlugRouteRouteWithChildren,
  AppWorkspaceSlugSettingsRouteRoute:
    AppWorkspaceSlugSettingsRouteRouteWithChildren,
  AppWorkspaceSlugBoardRoute: AppWorkspaceSlugBoardRoute,
  AppWorkspaceSlugCyclesRoute: AppWorkspaceSlugCyclesRoute,
  AppWorkspaceSlugInboxRoute: AppWorkspaceSlugInboxRoute,
  AppWorkspaceSlugMyIssuesRoute: AppWorkspaceSlugMyIssuesRoute,
  AppWorkspaceSlugPulseRoute: AppWorkspaceSlugPulseRoute,
  AppWorkspaceSlugStackRoute: AppWorkspaceSlugStackRoute,
  AppWorkspaceSlugStatsRoute: AppWorkspaceSlugStatsRoute,
  AppWorkspaceSlugWorkRoute: AppWorkspaceSlugWorkRoute,
  AppWorkspaceSlugIndexRoute: AppWorkspaceSlugIndexRoute,
}

const AppWorkspaceSlugRouteRouteWithChildren =
  AppWorkspaceSlugRouteRoute._addFileChildren(
    AppWorkspaceSlugRouteRouteChildren,
  )

interface AppRouteRouteChildren {
  AppWorkspaceSlugRouteRoute: typeof AppWorkspaceSlugRouteRouteWithChildren
  AppNewRoute: typeof AppNewRoute
}

const AppRouteRouteChildren: AppRouteRouteChildren = {
  AppWorkspaceSlugRouteRoute: AppWorkspaceSlugRouteRouteWithChildren,
  AppNewRoute: AppNewRoute,
}

const AppRouteRouteWithChildren = AppRouteRoute._addFileChildren(
  AppRouteRouteChildren,
)

interface AuthRouteRouteChildren {
  AuthForgotPasswordRoute: typeof AuthForgotPasswordRoute
  AuthLoginRoute: typeof AuthLoginRoute
  AuthSignupRoute: typeof AuthSignupRoute
}

const AuthRouteRouteChildren: AuthRouteRouteChildren = {
  AuthForgotPasswordRoute: AuthForgotPasswordRoute,
  AuthLoginRoute: AuthLoginRoute,
  AuthSignupRoute: AuthSignupRoute,
}

const AuthRouteRouteWithChildren = AuthRouteRoute._addFileChildren(
  AuthRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRouteRoute: AppRouteRouteWithChildren,
  AuthRouteRoute: AuthRouteRouteWithChildren,
  KitRoute: KitRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  DocsPageRoute: DocsPageRoute,
  GithubCallbackRoute: GithubCallbackRoute,
  InviteInvitationIdRoute: InviteInvitationIdRoute,
  SlackCallbackRoute: SlackCallbackRoute,
  DocsIndexRoute: DocsIndexRoute,
  PSlugChangelogRoute: PSlugChangelogRoute,
  PSlugIndexRoute: PSlugIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
